import postHog from "posthog-js";
import { config } from "./configuration";

if (config.postHogKey && config.postHogHost) {
  postHog.init(config.postHogKey, {
    api_host: config.postHogHost,
    defaults: "2026-05-30",
    person_profiles: "identified_only",
    // Only identify and pageviews for now; explicitly disabled so project settings cannot silently enable them.
    autocapture: false,
    capture_pageleave: false,
    capture_dead_clicks: false,
    rageclick: false,
    capture_heatmaps: false,
    capture_exceptions: false,
    capture_performance: false,
    disable_session_recording: true,
    disable_surveys: true,
    advanced_disable_feature_flags: true,
  });
}

export default postHog;
